// 基础路由映射
const routes = [
  {
    path: "/",
    component: () => import("@/views/cycor"),
    redirect: "/home",
    children: [
      // {
      //   // KYC认证
      //   name: "auth",
      //   path: "/",
      //   component: () => import("@/views/kYCIdentify/index"),
      //   meta: { noAuth: true, noCache: false },
      // },
    ],
  },

  {
    // cycor官网
    name: "cycor",
    path: "/home",
    component: () => import("@/views/cycor"),
    meta: { noAuth: true },
  },
  {
    // cycor官网
    name: "Cases",
    path: "/Cases",
    component: () => import("@/views/cycor/Cases"),
    meta: { noAuth: true },
  },
  {
    // cycor官网
    name: "Solution",
    path: "/Solution",
    component: () => import("@/views/cycor/Solution"),
    meta: { noAuth: true },
  },
  {
    name: "SolutionPlan",
    path: "/SolutionPlan",
    component: () => import("@/views/cycor/SolutionPlan"),
    meta: { noAuth: true },
  },

  // {
  //   // cycor官网 - 新联系我们页面（已下线）
  //   name: "ContactUs",
  //   path: "/ContactUs",
  //   component: () => import("@/views/cycor/ContactUs"),
  //   meta: { noAuth: true },
  // },

  {
    // cycor官网
    name: "privacy",
    path: "/privacy",
    component: () => import("@/views/cycor/cPolicy"),
    meta: { noAuth: true },
  },

  {
    name: "404",
    path: "/:catchAll(.*)",
    component: () => import("@/views/404"),
    meta: { noAuth: true },
  },
];
export default routes;
